export const truncateText = (text, wordLimit) => {
  const words = text?.split(" "); // Split the string into words
  if (words?.length > wordLimit) {
    return words.slice(0, wordLimit).join(" ") + "..."; // Limit words and add '...'
  }
  return text; // If within limit, return full text
};
